export const selectProfile = (s) => s?.profile;

export const selectProfileLoading = (s) => s?.profile?.loading;

export const selectProfileError = (s) => s?.profile?.error ?? null;

export const selectSource = (s) => s?.profile?.source ?? null;

export const selectCompany = (s) => s?.profile?.company;

export const selectUser = (s) => s?.profile?.user;

export const selectConsentEntry = (s) => s?.profile?.user?.consentEntry ?? null;

export const selectUserDetails = (s) => s?.profile?.user_details ?? {};

export const selectUac = (s) => s?.profile?.user_details?.uuid;

export const selectVerificationDetails = (s) => s?.profile?.verification_details ?? {};

export const selectMandatoryFields = (s) => s?.profile?.mandatory_fields ?? [];

export const selectSsnConfig = (s) => s?.profile?.ssn_config ?? null;

export const selectTheme = (s) => s?.profile?.company?.theme ?? {};

export const selectWorkflow = (s) => s?.profile?.workflow ?? {};

export const selectIdVerifications = (s) => s?.profile?.workflow?.id_verifications;

export const selectEnabledCountries = (s) => s?.profile?.workflow?.enabled_countries;

export const selectCompanyInfo = (s) => s?.profile?.user;

export const selectExtendedChecks = (s) => s?.profile?.extended_checks ?? {};

export const selectTestResult = (s) => s?.profile?.getTestResult ?? {};
